import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Avatar,
  Stack,
} from "@mui/material";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";

interface Testimonial {
  id: number;
  text: string;
  name: string;
  role: string;
  avatar: string;
}

const testimonials: Testimonial[] = [
  {
    id: 1,
    text: "Muzukuru provided exceptional care during our family's most difficult time. Their compassion and professionalism was truly comforting.",
    name: "Sarah Mulenga",
    role: "Grateful Family",
    avatar:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop",
  },
  {
    id: 2,
    text: "The team at Muzukuru handled everything with such dignity and respect. We couldn't have asked for better service.",
    name: "John Chikaola",
    role: "Client Since 2020",
    avatar:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop",
  },
  {
    id: 3,
    text: "From planning to execution, Muzukuru made sure every detail was perfect. Thank you for honoring our loved one.",
    name: "Grace Nyathi",
    role: "Forever Thankful",
    avatar:
      "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop",
  },
];

export default function ClientExperiences() {
  return (
    <Box
      sx={{
        backgroundColor: "#FFF8F1",
        py: { xs: 6, md: 10 },
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Decorative wave pattern */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          right: 0,
          width: "300px",
          height: "200px",
          opacity: 0.3,
          background: `repeating-linear-gradient(
            45deg,
            transparent,
            transparent 10px,
            #8b6f47 10px,
            #8b6f47 12px
          )`,
          borderRadius: "0 0 0 100%",
        }}
      />

      <Container maxWidth="lg">
        <Box textAlign="center" mb={6}>
          <Typography
            variant="h3"
            sx={{
              fontWeight: 600,
              color: "#3d2e1f",
              mb: 1,
              fontSize: { xs: "1.75rem", md: "2.5rem" },
            }}
          >
            Some Client Experiences
          </Typography>
          <Typography
            sx={{
              color: "#5a4a3a",
              fontSize: "1rem",
            }}
          >
            Here is what some of our clients say about us!
          </Typography>
        </Box>

        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={3}
          justifyContent="center"
          alignItems="stretch"
        >
          {testimonials.map((testimonial) => (
            <Card
              key={testimonial.id}
              sx={{
                flex: 1,
                maxWidth: { xs: "100%", md: "340px" },
                backgroundColor: "#f5f0e8",
                borderRadius: 3,
                boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                position: "relative",
                pt: 3,
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  top: 16,
                  left: 16,
                }}
              >
                <FormatQuoteIcon
                  sx={{
                    fontSize: 32,
                    color: "#8b6f47",
                    transform: "rotate(180deg)",
                  }}
                />
              </Box>
              <CardContent sx={{ pt: 4, pb: 3 }}>
                <Typography
                  sx={{
                    color: "#4a3c2d",
                    fontSize: "0.9rem",
                    lineHeight: 1.7,
                    mb: 3,
                    minHeight: "100px",
                  }}
                >
                  {testimonial.text}
                </Typography>
                <Stack direction="row" spacing={2} alignItems="center">
                  <Avatar
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    sx={{ width: 44, height: 44 }}
                  />
                  <Box>
                    <Typography
                      sx={{
                        fontWeight: 600,
                        color: "#3d2e1f",
                        fontSize: "0.9rem",
                      }}
                    >
                      {testimonial.name}
                    </Typography>
                    <Typography
                      sx={{
                        color: "#7a6a5a",
                        fontSize: "0.75rem",
                      }}
                    >
                      {testimonial.role}
                    </Typography>
                  </Box>
                </Stack>
              </CardContent>
            </Card>
          ))}
        </Stack>
      </Container>
    </Box>
  );
}
